"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("../index.vue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'CouponFrom',
  components: {
    couponList: _index.default
  },
  data: function data() {
    return {
      visible: false,
      callback: function callback() {},
      handle: '',
      keyNum: 0,
      coupons: [],
      userIds: '',
      userType: ''
    };
  },
  watch: {// show() {
    //   this.visible = this.show
    // }
  },
  methods: {
    handleClose: function handleClose() {
      this.visible = false;
    },
    getCouponId: function getCouponId(couponObj) {
      this.callback(couponObj);
      this.visible = false;
    }
  }
};
exports.default = _default;